import React from 'react';
import {Header, Segment, Divider, Grid} from 'semantic-ui-react';
import _ from 'lodash';
import {getItemNameFromRef} from 'common/utils';
import {connectWithCore} from 'framework/hocs';
import REST from 'go/requests/rest';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class ScoreDetails extends React.Component {
  state = {};

  componentDidMount() {
    const {grantId, token, scores, refItems} = this.props;

    if (refItems) {
      this.setState({
        refItems: refItems,
      });
    } else {
      this.getPartCodeList(scores);
    }
  }

  getPartCodeList(scores) {
    let partCodes = [];
    _.forEach(scores, (score) => {
      if (score.part) {
        partCodes.push(score.part);
      }
    });

    let partCode = _.filter(_.uniq(partCodes), (part) => {
      return !_.isNaN(_.toNumber(part));
    });

    REST.ref
      .getItemsByItemCodes(this.props.token, partCode)
      .then((res) => forceJsonResponse(res, FLUX))
      .then((itemData) => {
        this.setState({
          refItems: itemData,
        });
      })
      .catch((err) => {
        console.error('Error retrieving ItemCodes from Ref');
      });
  }

  renderFinalScores = (partId) => {
    const {finalScores} = this.props;
    const finalScoresforPart = _.find(finalScores, (score) => score.partId === partId);
    if (!finalScoresforPart) return null;
    return (
      <React.Fragment>
        <Grid.Row>
          <Grid.Column width="16">
            {/* <Divider /> */}
            <Header as="h4">Final scores</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="6">Panel score average</Grid.Column>
          <Grid.Column width="10">
            <strong>{_.get(finalScoresforPart, 'panelScore')}</strong>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="6">Pre-score</Grid.Column>
          <Grid.Column width="10">
            <strong>{_.get(finalScoresforPart, 'preScore')}</strong>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="6">Cumulative score</Grid.Column>
          <Grid.Column width="10">
            <strong>{_.get(finalScoresforPart, 'cumulativeScore')}</strong>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );
  };

  renderScoresByFactor = (partScores, partId) => {
    const {hideFinalScores} = this.props;
    const {toggles} = this.props.context.toggles;
    const userEmailTable = _.includes(toggles, 'userEmailTable');
    const scoreReviewer = userEmailTable ? 'emailAdr' : 'userId';

    const groupedScoresByFactor = _.groupBy(partScores, 'factor');
    return (
      <React.Fragment>
        {_.map(groupedScoresByFactor, (factorScores, factor) => (
          <React.Fragment key={factor}>
            <Grid.Row>
              <Grid.Column width="16">
                <Header as="h4">{factor}</Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width="6">Reviewer</Grid.Column>
              <Grid.Column width="10">
                <strong>Score</strong>
                <br />
                <strong>Comment</strong>
              </Grid.Column>
            </Grid.Row>
            {_.map(factorScores, (score, index) => (
              <Grid.Row key={index}>
                <Grid.Column width="6">{score[scoreReviewer]}</Grid.Column>
                <Grid.Column width="10">
                  <strong>{score.text ? score.text : score.value}</strong>
                  <br />
                  <strong>{score.justification}</strong>
                </Grid.Column>
              </Grid.Row>
            ))}
            <Divider />
          </React.Fragment>
        ))}
        {!hideFinalScores && this.renderFinalScores(partId)}
      </React.Fragment>
    );
  };

  render() {
    const {refItems} = this.state;
    const {scores, fundingStreams} = this.props;
    const groupedScoresByPart = _.groupBy(scores, 'partId');
    const generateHeader = (partScores, partId) => {
      const header =
        getItemNameFromRef(_.get(partScores, [0, 'part'], ''), refItems) ||
        _.get(partScores, [0, 'part'], '');
      const projectId = _.get(
        fundingStreams,
        `${partId}.additionalInformation.projectName`,
        ''
      ); //will be used in FPS as similar projects can belong to same activity
      return `${header} ${projectId}`;
    };
    return (
      <React.Fragment>
        {_.map(groupedScoresByPart, (partScores, partId) => (
          <React.Fragment key={partId}>
            <Header
              name={partId}
              as="h2"
              id={`item-${_.indexOf(
                _.keys(groupedScoresByPart),
                partId
              )}-children-${_.get(partScores, [0, 'partId'])}`}
            >
              {generateHeader(partScores, partId)}
            </Header>
            <Segment>
              <Grid>{this.renderScoresByFactor(partScores, partId)}</Grid>
            </Segment>
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }
}

export default connectWithCore(ScoreDetails);
